import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserQueue } from '../models/userQueue';

@Injectable({
  providedIn: 'root'
})
export class UserSupportService {
  private socket: WebSocket | null = null;
  private readonly userQueueSubject = new Subject<UserQueue[]>();
  private reconnectionAttempts = 0;
  private readonly maxReconnectionAttempts = 10;

  constructor() { }

  public connectWebSocket(operatorId: string): void {
    this.createWebSocket(operatorId);
  }

  private createWebSocket(operatorId: string): void {
    this.socket = new WebSocket(`${environment.webSocketUrl}/operator/${operatorId}`);
    //this.socket = new WebSocket(`ws://localhost:80/websocket/operator/${operatorId}`);

    this.socket.onopen = (): void => {
      console.log('WebSocket connected');

      this.reconnectionAttempts = 0; // Reset reconnection attempts on successful connection
    };

    this.socket.onmessage = (event): void => {
      const data = JSON.parse(event.data) as { type?: string; value?: unknown };
      if (data.type === 'userQueue' && Array.isArray(data.value)) {
        this.userQueueSubject.next(data.value as UserQueue[]);
      }
    };

    this.socket.onclose = (): void => {
      console.log('WebSocket disconnected');

      if (this.reconnectionAttempts < this.maxReconnectionAttempts) {
        this.reconnectionAttempts++;

        console.log(`Attempting to reconnect (Attempt ${this.reconnectionAttempts} of ${this.maxReconnectionAttempts})`);

        const isAvailable = sessionStorage.getItem('isAvailable')?.toLowerCase() === 'true';

        setTimeout(() => {
          if (isAvailable) {
            this.createWebSocket(operatorId); // Reconnect after a delay
          }
        }, 3_000); // 3 seconds delay, you can adjust this as needed
      } else {
        console.log('Exceeded maximum reconnection attempts. Please handle this scenario.');
        // Here you can add further logic like notifying the user or handling the situation
      }
    };

    this.socket.onerror = (error): void => {
      console.error('WebSocket Error:', error);
    };

    window.addEventListener("beforeunload", () => {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify({ type: "close_tab" }));
      }
    });
  }

  public getUserQueue(): Subject<UserQueue[]> {
    return this.userQueueSubject;
  }

  public sendMessage(message: any): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    }
  }

  public sendFinishChat(userId: string, operatorId: string): void {
    this.sendMessage({ type: 'closeChatWindow', userId, operatorId });
  }

  public disconnectWebSocket(): void {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}
